import { render, staticRenderFns } from "./HomeRegionCards.vue?vue&type=template&id=c6408e94&scoped=true"
import script from "./HomeRegionCards.vue?vue&type=script&lang=js"
export * from "./HomeRegionCards.vue?vue&type=script&lang=js"
import style0 from "./HomeRegionCards.vue?vue&type=style&index=0&id=c6408e94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6408e94",
  null
  
)

export default component.exports